let capturedToken = null;

export function captureMagicLinkToken(locationLike, historyLike) {
  if (!locationLike?.hash) return null;
  const params = new URLSearchParams(locationLike.hash.slice(1));
  const token = params.get("auth_token");
  if (!token) return null;
  params.delete("auth_token");
  const remaining = params.toString();
  const cleanUrl = `${locationLike.pathname || "/"}${locationLike.search || ""}${remaining ? `#${remaining}` : ""}`;
  historyLike?.replaceState?.(historyLike.state ?? null, "", cleanUrl);
  return token;
}

export function takeCapturedMagicLinkToken() {
  const token = capturedToken;
  capturedToken = null;
  return token;
}

if (typeof window !== "undefined") {
  capturedToken = captureMagicLinkToken(window.location, window.history);
}
